import { useTenants } from '@/services/tenants/useTenants';
import { KeyboardArrowDown } from '@mui/icons-material';
import { ButtonBase, Divider, ListItemText, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CrumbButton = styled(ButtonBase)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2px',
  color: theme.palette.text.primary,
  borderRadius: '4px',
  padding: '2px 4px',
  fontSize: '0.875rem',
  '&:hover': { background: theme.palette.action.hover },
}));

export const BatchBreadcrumbDropdown = ({
  batchId,
  label,
  siblings,
  currentReportId,
}: {
  batchId: string;
  label: string;
  siblings: { id: string; partNumber: string }[];
  currentReportId: string | undefined;
}) => {
  const { getPath } = useTenants();
  const navigate = useNavigate();
  const [anchorElement, setAnchorElement] = useState<HTMLElement>();

  const goTo = (path: string) => {
    setAnchorElement(undefined);
    navigate(getPath(path));
  };

  return (
    <>
      <CrumbButton onClick={event => setAnchorElement(event.currentTarget)} data-testid='batch-breadcrumb-dropdown'>
        {label}
        <KeyboardArrowDown sx={{ fontSize: '18px' }} />
      </CrumbButton>
      <Menu
        anchorEl={anchorElement}
        open={!!anchorElement}
        onClose={() => setAnchorElement(undefined)}
        slotProps={{ paper: { sx: { maxHeight: 360 } } }}
      >
        <MenuItem onClick={() => goTo(`part-finder/batches/${batchId}`)}>
          <ListItemText>View batch</ListItemText>
        </MenuItem>
        <Divider />
        {siblings.map(sibling => (
          <MenuItem
            key={sibling.id}
            selected={sibling.id === currentReportId}
            onClick={() => goTo(`part-finder-reports/${sibling.id}`)}
          >
            <ListItemText>{sibling.partNumber}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
